import PropTypes from 'prop-types'

export default function ToolbarButton({
  disabled,
  title,
  tooltip,
  icon,
  onClick,
  active,
}) {
  return (
    <button
      className={`
      tw-custom-uppercase 
      tw-custom-disabled
      tw-py-2 
      tw-px-3 
      tw-border 
      tw-duration-100 
      tw-ease-linear 
      tw-border-solid
      focus:tw-outline-none
      focus:tw-ring
      ${
        disabled
          ? 'tw-bg-system-grey-50 tw-text-system-grey-200 tw-cursor-not-allowed tw-border-system-grey-200'
          : !active
          ? 'tw-bg-system-grey-50 tw-border-system-grey-200'
          : 'tw-bg-primary tw-border-primary tw-text-white'
      }`}
      title={tooltip}
      disabled={disabled}
      onClick={event => {
        event.stopPropagation()
        onClick && onClick(event)
      }}>
      <i className={`fas fa-${icon} tw-mr-3`} />
      {title}
    </button>
  )
}

ToolbarButton.propTypes = {
  disabled: PropTypes.bool,
  title: PropTypes.string,
  tooltip: PropTypes.string,
  icon: PropTypes.string,
  onClick: PropTypes.func,
  active: PropTypes.bool,
}

export function ToolbarDropdownButton({
  disabled,
  title,
  icon,
  onClick,
  active,
}) {
  return (
    <button
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
      className={`
      dropdown-toggle
      tw-bg-white
      tw-custom-uppercase 
      tw-py-2 
      tw-px-3 
      tw-border 
      tw-duration-100 
      tw-ease-linear 
      tw-border-solid 
      tw-border-system-grey-200 
      ${
        disabled
          ? 'tw-text-system-grey-200 tw-cursor-not-allowed'
          : 'tw-text-system-grey-900'
      }
      ${
        active && !disabled
          ? 'tw-font-bold tw-border-2'
          : 'tw-border tw-font-base'
      }`}
      disabled={disabled}
      onClick={onClick}>
      <i className={`fas fa-${icon} tw-mr-3`} />
      {title}
      <i className={`fas fa-angle-down tw-ml-4`} />
    </button>
  )
}

ToolbarDropdownButton.propTypes = {
  disabled: PropTypes.bool,
  title: PropTypes.string,
  icon: PropTypes.string,
  onClick: PropTypes.func,
  active: PropTypes.bool,
}

export function DropdownItem({ icon, title, active, disabled, onClick }) {
  return (
    <li
      className={`tw-cursor-pointer
    ${
      disabled
        ? 'disabled tw-cursor-not-allowed tw-border-system-grey-200'
        : active
        ? 'active'
        : ''
    }`}>
      <a href="#" onClick={!disabled ? onClick : null}>
        <i className={`fas fa-${icon} tw-mr-3`} /> {title}
      </a>
    </li>
  )
}

DropdownItem.propTypes = {
  icon: PropTypes.string.isRequired,
  title: PropTypes.string,
  active: PropTypes.bool,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
}
